<div class="button-renewed">
  <button mat-flat-button
          class="custom-button"
          [ngStyle]="width ? {'width': width} : {}"
          [ngClass]="{'selected': isSelected}"
          (click)="toggleSelection()">
    {{textInput || ''}}
  </button>
</div>
